import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Container} from '../../../container';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {EquipmentLoadoutHelper, EquipmentItem} from '../../../equipment-loadout-helper';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';

import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-container-dialog',
    templateUrl: './container-dialog.component.html',
    styleUrls: ['./container-dialog.component.sass'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, FormsModule, MatAutocompleteTrigger, MatAutocomplete, MatOption, MatDialogActions, MatButton, MatDialogClose]
})
export class ContainerDialogComponent implements OnInit {
  container: Container;
  slung_items: Container[];
  equipmentCatalog: EquipmentItem[];
  filteredEquipment: EquipmentItem[];
  templateFilter: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ContainerDialogComponent>
  ) {
    this.container = data.container;
    this.slung_items = data.slung_items;
    this.equipmentCatalog = EquipmentLoadoutHelper.getEquipmentCatalog()
      .filter(e => e.slingable);
    this.filteredEquipment = this.equipmentCatalog;
  }

  ngOnInit(): void {
  }

  filterTemplates(): void {
    if (!this.templateFilter) {
      this.filteredEquipment = this.equipmentCatalog;
      return;
    }
    const filter = this.templateFilter.toLowerCase();
    this.filteredEquipment = this.equipmentCatalog.filter(e =>
      e.name.toLowerCase().includes(filter)
    );
  }

  onTemplateSelect(event): void {
    const name = event.option.value;
    const selected = this.equipmentCatalog.find(e => e.name === name);
    if (selected) {
      this.container.name = selected.name;
      this.container.weight = selected.weight;
      if (selected.capacity)
        this.container.capacity = selected.capacity;
      if (selected.slots)
        this.container.slots = selected.slots;
    }
  }

  formatGp(copper: number): string {
    const gp = Math.floor(copper / 100);
    const sp = Math.floor((copper % 100) / 10);
    const cp = copper % 10;
    let result = gp + 'gp';
    if (sp > 0) result += ' ' + sp + 'sp';
    if (cp > 0) result += ' ' + cp + 'cp';
    return result;
  }

  deleteContainer() {
    this.container.delete();
    this.dialogRef.close();
  }

  upsertContainer() {
    if (this.slung_items)
      this.slung_items.push(this.container);
  }
}
